import { render, staticRenderFns } from "./CreatePin.vue?vue&type=template&id=b8c97824"
import script from "./CreatePin.vue?vue&type=script&lang=js"
export * from "./CreatePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports